import { Container } from 'aurelia-dependency-injection';
import $ from 'jquery';
import { YoutubeAPI } from '../../services/youtubeAPI';


export class CaseStudyBase {
    constructor(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, apiBase, api, envService, isAdmin = false) {


        this.isAdmin = isAdmin;
        this.authService = authService;
        this.userMessageService = userMessageService;
        this.router = router;
        this.envService = envService;

        this.apiBase = apiBase;
        this.api = api;


        this.bgMusicApi = bgMusicApi;
        this.fontApi = fontApi;
        this.accountApi = accountApi;
        this.youtubeApi = new YoutubeAPI(this.youtubeAPILoaded.bind(this), this.youtubeApiReady.bind(this), this.apiBase);

        console.log('----------------')
        console.log(this.youtubeApi)
        // this.facebookApi = facebookApi;
       // this.facebookApi.setCallbacks(this.facebookApiLoaded.bind(this), this.facebookApiReady.bind(this));

        this.background_music = null;

        this.youtubeReady = false;
       // this.facebookReady = false;

        this.saving = false;
        this.sending = false;

        window.googleApiClientReady = this.youtubeApi.googleApiClientReady.bind(
          this.youtubeApi
        );
       // window.fbAsyncInit = this.facebookApi.facebookApiClientReady.bind(this.facebookApi);

        this.questionsMax = 55;
        this.callToActionMax = 16;

        this.socialMediaUploading = false;
        this.remove_cta = false;

        this.editable = true;

        this.loading = true;

        this.app_name = "Magnfi";


        if(window.whitelabel) {

          this.app_name = window.app_name;
        }

        this.fileBase = '';

        this.isWLAdmin = false;
        if (this.authService.getUser().role === 'WLADMIN') {
            this.isWLAdmin = true;
        }

        this.customCTAImageEnable = false;
    }



    activate(params, route) {
        console.log("activated");
        this.backgroundMusicList = null;
        this.bgWebPath = null;
        this.bgContentType = null;

        this.status = null;

        //this.reset();

        this.id = params.id;



        this.video_src = this.apiBase + "/caseStudy/getProducedVideo/";
        this.submitted_src = this.apiBase + "/caseStudy/getSubmittedVideo/";
        this.cta_src = this.apiBase + "/caseStudy/getCustomCTA/";



        if (this.authService.getAccount() != null && this.authService.getAccount().owner_user_id != null && this.authService.getAccount().logo_file != null) {
            this.account_owner_user_id = this.authService.getAccount().owner_user_id;

        }
        else {
            this.userMessageService.setUserMessage("user", "Please set up account.");
            if (this.authService.getAccount().logo_file == null)
                this.userMessageService.setUserMessage("user", "Logo is required.");
            this.router.navigate("account");
        }



        this.question1CharsLeft = this.questionsMax;
        this.question2CharsLeft = this.questionsMax;
        this.question3CharsLeft = this.questionsMax;
        this.callToActionCharsLeft = this.callToActionMax;

        this.showVideo = false;

        this.socialMediaUploading = false;

        this.call_to_action_select = -1;


        //if(this.facebookApi.loaded)
        //    this.facebookApiLoaded();

        this.testimonial_expire_days = window.testimonial_expire_days;

        this.hasCustomOpener = false;

        this.account_org_phone = this.authService.getAccount().org_phone;
        this.account_org_email = this.authService.getAccount().org_email;
        this.account_website = this.authService.getAccount().website;

        this.isMobile = this.envService.isMobile();

        if(this.id) {
            // this.api.getFileList(
            //     this.id,
            //     this.authService.getUser().token,
            //     this.getFileListSuccess.bind(this),
            //     this.saveLoadError.bind(this));
        }
        if (this.id) {
            this.load();
        }

        this.captureOverride_files = [];


    }

    attached() {

        this.rout = window.location.href;
        console.log("Case study URL:",this.rout);
        if(!this.rout.includes("#/wladmin/video/case/new/") && !this.rout.includes("#/admin/video/case/new/") && !this.rout.includes("#/ytmanager/video/case/new"))
        {
            this.caseStudyListt.activate();
        }
        this.videoPreviewPlayer.addEventListener("blur",
            function (e) {
                //this.showVideoClosed()

            }.bind(this));

        this.loadBgMusic();

        if (this.bgPreviewPlayer) {
            this.bgPreviewPlayer.pause();

        }

    }

    detached() {
        if (this.bgPreviewPlayer) {
            this.bgPreviewPlayer.pause();

        }

        if (this.videoPreviewPlayer) {
            this.videoPreviewPlayer.pause();
        }
    }


    loadBgMusic() {
        this.bgMusicApi.getBackgroundMusicList(
            this.authService.getUser().token,
            this.loadBgMusicSuccess.bind(this),
            this.saveLoadError.bind(this));
    }


    loadBgMusicSuccess(data) {
        this.backgroundMusicList = data;

        this.loadFonts();

    }

    loadFonts() {
        this.fontApi.getFontList(
            this.authService.getUser().token,
            this.loadFontSuccess.bind(this),
            this.saveLoadError.bind(this));
    }


    loadFontSuccess(data) {
        this.fontList = data;
        this.call_to_action_font = this.fontList[0];

        if (this.id) {
            this.load();
        } else {
            this.reset();
        }

    }

    bgMusicChanged() {

        if (this.background_music && this.background_music != -1) {
            if(this.background_music.id == 0)
                this.bgPreviewPlayer.src = null;
            else
                this.bgPreviewPlayer.src = "api/backgroundMusic/getMusicFile/" + this.background_music.id + "?Authorization=" + this.authService.getUser().token;


        } else {
            var rand = Math.floor(Math.random() * this.backgroundMusicList.length - 1);

            this.background_music = this.backgroundMusicList[rand];
            this.bgPreviewPlayer.src = "api/backgroundMusic/getMusicFile/" + this.background_music.id + "?Authorization=" + this.authService.getUser().token;


        }
        this.bgPreviewPlayer.pause();
        this.bgPreviewPlayer.load();

        this.bgPreviewPlayer.volume = 0.8;
    }

    reset() {
        this.status = 0;
        this.status_text = "New";
        this.customer_first_name = null;
        this.customer_last_name = null;
        this.customer_email = null;

        this.video_name = null;

        this.call_to_action = null;

        this.question_1 = null;
        this.question_2 = null;
        this.question_3 = null;
        this.include_email = false;
        this.include_phone = false;
        this.include_call_to_action = true;
        this.cta_override_website = this.account_website;

        //if (this.backgroundMusicList)
        //    this.bgMusicChanged();

        this.public = false;
        this.featured = false;
        this.customCTALink = null;
        this.remove_cta = false;

        this.editable = true;

        if(this.isAdmin) {
            this.accountApi.hasCustomOpener(
                this.account_owner_user_id,
                this.authService.getUser().token,
                (result) => {this.hasCustomOpener = result;},
                this.saveLoadError.bind(this));

        } else {
            this.accountApi.hasCustomOpener(
                { type: "horizontal" },
                this.authService.getUser().token,
                (result) => {this.hasCustomOpener = result;},
                this.saveLoadError.bind(this));
        }

        // this.accountApii.getUserData(
        //     this.account_owner_user_id,
        //     this.authService.getUser().token,
        //     (userData) => {
        //         this.account_org_phone = userData.account.org_phone;
        //         this.account_org_email = userData.account.org_email;
        //         this.account_website = userData.account.website;
        //         super.reset();
        //     },
        //     this.saveLoadError.bind(this));


    }

    rowClicked(item, $event) {
        console.log("Item is from base ",item);
        if($event.originalTarget && ($event.originalTarget.parentNode.classList.contains('tb_checkbox') ||
            $event.originalTarget.classList.contains('tb_checkbox')) )
            return true;
        if(item.status !=2 && item.status !=3 )
            this.router.navigate("video/caseStudy/" + item.id);
    }
    load() {
        this.api.getById(
            this.id,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }

    save() {

        if (this.validate()) {
            this.saving = true;
            this.api.save(
                this.getData(),
                (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
                this.authService.getUser().token,
                this.saveLoadSuccess.bind(this),
                this.saveLoadError.bind(this));

            //this.saving = false;
        }
    }

    saveLoadSuccess(data) {
        this.setData(data);

        if(this.customCTAImageEnable)
        {
            this.api.sendRequest(
                this.getData(),
                this.authService.getUser().token,
                this.saveLoadSuccess.bind(this),
                this.saveLoadError.bind(this));

            this.customCTAImageEnable = false;
        }

        console.log("Save success start!");
        if(this.isAdmin) {
            this.accountApi.hasCustomOpener(
                this.account_owner_user_id,
                this.authService.getUser().token,
                (result) => {this.hasCustomOpener = result;},
                this.saveLoadError.bind(this));

        } else {

              this.accountApi.hasCustomOpener(
                { type: "horizontal" },
                this.authService.getUser().token,
                (result) => {this.hasCustomOpener = result;},
                this.saveLoadError.bind(this));
        }
        console.log(this.saving);
        console.log(this.sending);
        console.log(data.status);
        console.log("Save success Middle!");
        if (this.saving && data.status!=201)
            this.userMessageService.setUserMessage("user", "Saved!");
        if (this.sending && data.status!=201)
            this.userMessageService.setUserMessage("user", "Sent!");
        if (data.status==201)
            this.userMessageService.setUserError("user", "Deleted!");

        this.sending = false;
        this.saving = false;
        this.showCTAUpload = false;
        if(data.status==200 || data.status==201)
        {
            const vidoePageSite = window.location.href;
            if(vidoePageSite.includes("user"))
            {
                console.log("window.site_url...user")
                this.router.navigate(window.site_url+'#/user'+'/video/caseStudy');
            }

            else if(vidoePageSite.includes("wladmin"))
            {
                console.log("window.site_url...wladmin")
                this.router.navigate(window.site_url+'#/wladmin'+'/videos');
            }

            else if(vidoePageSite.includes("admin"))
            {
                console.log("window.site_url...admin")
                this.router.navigate(window.site_url+'#/admin'+'/videos');
            }
        }

        console.log("Save success end!");
    }

    saveLoadError(msg) {
        this.socialMediaUploading = false;
        this.userMessageService.setUserError("user", msg);

    }

    saveLoadSuccessDelete(data)
    {
        this.sending = false;
        this.saving = false;
        this.showCTAUpload = false;
        if(data.status==200 || data.status==201)
        {
            const vidoePageSite = window.location.href;
            if(vidoePageSite.includes("user"))
            {
                console.log("window.site_url...user")
                this.router.navigate(window.site_url+'#/user'+'/video/caseStudy');
            }

            else if(vidoePageSite.includes("wladmin"))
            {
                console.log("window.site_url...wladmin")
                this.router.navigate(window.site_url+'#/wladmin'+'/videos');
            }

            else if(vidoePageSite.includes("admin"))
            {
                console.log("window.site_url...admin")
                this.router.navigate(window.site_url+'#/admin'+'/videos');
            }

            this.userMessageService.setUserError("user", "Deleted!");
        }
    }

    setData(data) {
        this.id = data.id;
        this.account_owner_user_id = data.account_owner_user_id;
        this.status = data.status;
        this.status_text = data.status_text;
        this.customer_first_name = data.customer_first_name;
        this.customer_last_name = data.customer_last_name;
        this.customer_email = data.customer_email;
        this.customer_name = data.customer_first_name+" "+data.customer_last_name;
        this.video_name = data.video_name;
        this.sent_date = data.sent_date;
        this.capture_date = data.capture_date;
        this.expire_date = data.expire_date;

        this.call_to_action = data.call_to_action;
        //this.background_music = this.findBgMusic(data.background_music_id);
        this.question_1 = data.question_1;
        this.question_2 = data.question_2;
        this.question_3 = data.question_3;
        this.include_email = data.include_email;
        this.include_phone = data.include_phone;
        this.include_call_to_action = data.include_call_to_action;
        this.cta_override_website = data.cta_override_website;
        //this.bgMusicChanged();
        this.callToActionKeyUp();

        this.question1KeyUp();
        this.question2KeyUp();
        this.question3KeyUp();

        if (this.status == (this.link_submission || this.brand_video ? 3 : 4) || this.status == 100) {
            this.videoPreviewPlayer.src = this.video_src + this.id + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date();
            this.videoPreviewPlayer.load();
        }


        this.public = data.public;
        this.featured = data.featured;

        this.customCTALink = data.custom_cta ? this.cta_src + this.id + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date() : null;

        //this.call_to_action_font = this.findFont(data.font_id);
        this.useCustomOpener = data.use_custom_opener;
        this.removeStartOpenerLogo=data.remove_start_opener_logo;

        this.processing_failed = data.processing_failed || false;

        if(this.isAdmin) {

            this.editable = this.status == 0 || this.status == 4 || this.status == 100;


            this.editable = this.editable || (this.processing_failed && this.status < 200);
        } else {

            this.editable = this.status == 0;

        }

        //super.setData(data);

        // this.accountApi.getUserData(
        //     this.account_owner_user_id,
        //     this.authService.getUser().token,
        //     (userData) => {
        //         this.account_org_phone = userData.account.org_phone;
        //         this.account_org_email = userData.account.org_email;
        //         this.account_website = userData.account.website;
        //     },
        //     this.saveLoadError.bind(this));

        this.capture_override_1 = data.capture_override_1;
        this.capture_override_2 = data.capture_override_2;
        this.capture_override_3 = data.capture_override_3;

    }
    reproduce(setReady = false) {
        this.saving = true;
        var data = this.getData();
        data.set_ready = setReady;
        this.api.reproduce(
            data,
            (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }
    getFileListSuccess(files) {
        this.files = files;

        this.fileBase = this.apiBase + "/caseStudy/downloadFile/" + this.id;


    }
    uploadCaptureOverride(num) {
        if (this.captureOverride_files[num - 1] && this.captureOverride_files[num - 1].length > 0) {
            this.saving = true;
            this.api.saveCaptureOverride(this.id, num,
                this.captureOverride_files[num - 1][0],
                this.authService.getUser().token,
                () => {this.overrideCaptureChanged(num, true)},
                (msg) => { this.userMessageService.setUserError("user", msg)});
        }
    }

    removeCaptureOverride(num) {
        this.saving = true;
        this.api.removeCaptureOverride(this.id, num,
            this.authService.getUser().token,
            () => {this.overrideCaptureChanged(num, false)},
            (msg) => { this.userMessageService.setUserError("user", msg)});
    }

    overrideCaptureChanged(num, capture_override) {
        this.userMessageService.setUserMessage("user", "Saved!");

        this.saving = false;

        switch(num) {
            case 1:
                this.capture_override_1 = capture_override;
            break;
            case 2:
                this.capture_override_2 = capture_override;
            break;
            case 3:
                this.capture_override_3 = capture_override;
            break;
        }

        this.api.getFileList(
            this.id,
            this.authService.getUser().token,
            this.getFileListSuccess.bind(this),
            (msg) => { this.userMessageService.setUserError("user", msg)});

    }
    getData() {
        var data = {
            "id": this.id || null,
            "account_owner_user_id": this.account_owner_user_id,
            "customer_first_name": this.customer_first_name,
            "customer_last_name": this.customer_last_name,
            "customer_email": this.customer_email,
            "video_name": this.video_name,
            "call_to_action": this.call_to_action,
            "background_music_id": this.background_music ? this.background_music.id : '',
            "question_1": this.question_1,
            "question_2": this.question_2,
            "question_3": this.question_3,
            "include_email": this.include_email,
            "include_phone": this.include_phone,
            "include_call_to_action": this.include_call_to_action,
            "cta_override_website": this.cta_override_website,
            "remove_cta": this.remove_cta,
            "use_custom_opener": this.useCustomOpener,
            "remove_start_opener_logo":this.removeStartOpenerLogo,
            "font_id": this.call_to_action_font ? this.call_to_action_font.id : 0
        }

        return data;
    }

    findBgMusic(id) {
        for (var i = 0; i < this.backgroundMusicList.length; i++) {
            if (this.backgroundMusicList[i].id == id)
                return this.backgroundMusicList[i];
        }

        var rand = Math.floor(Math.random() * this.backgroundMusicList.length);
        return this.backgroundMusicList[rand];



    }

    bgMusicComparer(bg1, bg2) {

        if (bg1 && bg2)
            return bg1.id == bg2.id;

        return false;
    }

    findFont(id) {
        for (var i = 0; i < this.fontList.length; i++) {
            if (this.fontList[i].id == id)
                return this.fontList[i];
        }




    }

    fontComparer(font1, font2) {

        if (font1 && font2)
            return font1.id == font2.id;

        return false;
    }

    send() {
        if (this.validate()) {
            this.sending = true;

            if(this.cta_files && this.cta_files.length > 0)
            {
                this.customCTAImageEnable = true;
                this.api.save(
                    this.getData(),
                    (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
                    this.authService.getUser().token,
                    this.saveLoadSuccess.bind(this),
                    this.saveLoadError.bind(this));
            }
            else
            {
                this.api.sendRequest(
                    this.getData(),
                    this.authService.getUser().token,
                    this.saveLoadSuccess.bind(this),
                    this.saveLoadError.bind(this));
            }
        }
        //this.sending = false;
    }

    question1KeyUp() {
        var len = this.question_1 == null ? 0 : this.question_1.length;

        if (len > this.questionsMax) {
            this.question_1 = this.question_1.substring(0, this.questionsMax);
        } else {
            this.question1CharsLeft = this.questionsMax - len;
        }
    }

    question2KeyUp() {
        var len = this.question_2 == null ? 0 : this.question_2.length;

        if (len > this.questionsMax) {
            this.question_2 = this.question_2.substring(0, this.questionsMax);
        } else {
            this.question2CharsLeft = this.questionsMax - len;
        }
    }

    question3KeyUp() {
        var len = this.question_3 == null ? 0 : this.question_3.length;

        if (len > this.questionsMax) {
            this.question_3 = this.question_3.substring(0, this.questionsMax);
        } else {
            this.question3CharsLeft = this.questionsMax - len;
        }
    }



    callToActionKeyUp() {

        var len = this.call_to_action == null ? 0 : this.call_to_action.length;

        if (len > this.callToActionMax) {
            this.call_to_action = this.call_to_action.substring(0, this.callToActionMax);
        } else {
            this.callToActionCharsLeft = this.callToActionMax - len;
        }

    }

    callToActionChanged() {
        if (this.call_to_action_select != -1)
            this.call_to_action = this.call_to_action_select;

        this.callToActionKeyUp();

        this.callToActionCtrl.focus();

    }

    validate() {
        var pass = true;
        if(!this.brand_video) {
            if (this.customer_first_name == null || this.customer_first_name.trim() == '') {
                this.userMessageService.setUserError("user", "Customer First Name is empty");
                pass = false;
            }
            if (this.customer_email == null || this.customer_email.trim() == '') {
                this.userMessageService.setUserError("user", "Customer Email is empty");

                pass = false;
            }

            if(!this.is_email(this.customer_email)) {
                this.userMessageService.setUserError("user", "Customer Email is not a valid email address");
                pass = false;
            }
        }

        if (this.include_call_to_action && this.customCTALink == null && (this.call_to_action == null || this.call_to_action.trim() == '')) {
            this.userMessageService.setUserError("user", "Call To Action is empty");

            pass = false;
        }


        return pass;

    }

    is_email(email)
    {
        var emailReg = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailReg.test(email);
    }

    accept() {
        if (confirm("Are you sure you want to accept this video?")) {
            if (this.validate()) {
                this.saving = true;
                this.api.acceptVideo(
                    this.getData(),
                    (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
                    this.authService.getUser().token,
                    this.saveLoadSuccess.bind(this),
                    this.saveLoadError.bind(this));
            }
        }
    }

    delete() {
        if (confirm("Are you sure you want to delete this video?")) {
            this.saving = true;
            this.api.deleteVideo(
                this.getData(),
                this.authService.getUser().token,
                this.saveLoadSuccessDelete.bind(this),
                this.saveLoadError.bind(this));
        }
    }

    download() {
        window.open(this.videoPreviewPlayer.src, "_blank");
    }

    downloadSubmittedvideo(num) {
        window.open(this.submitted_src + this.id + "/" + num + "?Authorization=" + this.authService.getUser().token + "&t=" + new Date(), "_blank");
    }

    showVideoClicked() {
        this.showVideo = true;
        //setTimeout(function () {
        //    this.videoPreviewPlayer.focus();

        //}.bind(this), 100);
        this.videoPreviewPlayer.play();
    }

    showVideoClosed() {
        this.showVideo = false;
        if (this.videoPreviewPlayer) {
            this.videoPreviewPlayer.pause();
        }
    }

    //Youtube API

    youtubeAPILoaded() {
      console.log("alet")

      this.youtubeApi.getClientId(this.authService.getUser().token, this.youtubeConfigured.bind(this), this.saveLoadError.bind(this));
      }

    youtubeConfigured() {
        //this.youtubeApi.checkAuth();
        this.youtubeApiReady();
    }

    youtubeApiReady() {
        this.youtubeReady = true;
    }

    youtubeAuthRequired() {
        this.youtubeApi.loginToYoutube();
    }

    startYoutubeUpload() {
        this.showSocialMediaUploadDialog(this.doYoutubeUpload.bind(this));
    }

    doYoutubeUpload() {
        this.socialMediaUploading = true;
        this.youtubeApi.uploadToYoutube(this.id, 4,  this.socialMediaTitle,
          this.socialMediaTags,
          this.socialMediaDescription,
          this.videoVisibitily,
          this.uploadDefault, this.authService.getUser().token, this.socialMediaUploadSuccess.bind(this), this.saveLoadError.bind(this));
    }

    uploadToYoutube() {
        if (this.youtubeApi.access_token)
           this.startYoutubeUpload();
        else
            this.youtubeApi.loginToYoutube(this.startYoutubeUpload.bind(this));
    }


    showSocialMediaUploadDialog(callback) {
        this.socialMediaTitle = "";
        this.socialMediaDescription = "";
        this.socialMediaUploadCallback = callback;
        this.showSocialMediaDialog = true;
        $('body').addClass('lock-position');
    }

    uploadToSocialMedia() {
        this.socialMediaUploadCallback();
        this.socialMediaUploadCallback = null;
    }

    cancelUpload() {
        this.showSocialMediaDialog = false;
        this.socialMediaUploading = false;
        $('body').removeClass('lock-position');
    }

    socialMediaUploadSuccess() {
        this.socialMediaUploading = false;
        this.showSocialMediaDialog = false;
        this.userMessageService.setUserMessage("user", "Upload Complete");
        $('body').removeClass('lock-position');

    }

    visibilityChange(value){
      this.videoVisibitily=value

    }


    isPublicChanged() {
        this.api.setPublic(
            this.id,
            this.public,
            this.authService.getUser().token,
            (value) => {
                if(!value)
                    this.featured = false;
            },
            this.saveLoadError.bind(this));
    }

    isFeaturedChanged() {
        this.api.setFeatured(
            this.id,
            this.featured,
            this.authService.getUser().token,
            (featured) => {this.featured = featured;},
            (error) => {this.featured = false; this.saveLoadError(error);});
    }

    uploadCTA() {
        this.showCTAUpload = true;
        this.remove_cta = false;
    }

    removeCTA() {

        this.remove_cta = true;
        this.customCTALink = null;
        this.cta_files = null;
    }

    customCTAChanged() {

        if (this.cta_files && this.cta_files[0] && typeof FileReader === "function") {

            var reader = new FileReader();

            reader.onload = (e) => {
                this.customCTALink = e.target.result;
            };

            reader.readAsDataURL(this.cta_files[0]);
        }

    }

}
